import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { SettingsDetails } from '../../models/settings.model';
import { ISettingsService } from '../../interfaces/settings.abstract.service';
@Injectable()
export class DefaultSettingsService extends ISettingsService {

    _settingsList: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    settingsList$: Observable<any> = this._settingsList.asObservable();
    _settingsDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    settingsDetails$: Observable<any> = this._settingsDetails.asObservable();
    _settingsSaveStatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    settingsSaveStatus$: Observable<any> = this._settingsSaveStatus.asObservable();

    fetchUserSettingsSummary(): void {};
    fetchUserSettingsDetails(functionName: string, functionType: string): any {
        this._settingsDetails.next(null);
        return undefined;
    }
    saveUserSettings(settingsData: any): any {
        this._settingsDetails.next(null);
        this._settingsSaveStatus.next(false);
        return undefined;
    }
    modifyUserSettings(settingsData: SettingsDetails, action: string, isRetry?: boolean): any {
        this._settingsDetails.next(null);
        this._settingsSaveStatus.next(false);
        return undefined;
    }
}
